import { transition } from '@helpers/animate';
import { imageCoverContainer, imageWrapperPreserveRatio } from '@helpers/aspectRatio';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { Device, from, until } from '@helpers/media';
import { contentStyles } from '@helpers/typography';
import { ButtonStyles } from '@stories/Components/Buttons/GeneralButton/Button.styles';
import styled, { css } from 'styled-components';
const ContainerStyles = css `
  border-radius: ${fluid(25, 50)};
  overflow: hidden;
  text-decoration: none;
  display: block;
  box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.25);
`;
const Container = styled.a `
  ${ContainerStyles}

  &:focus {
    outline: none;
  }

  &.focus-ring {
    outline: auto;
    outline-offset: 3px;
    outline-color: ${brand.black};
  }
`;
const ArticleContainer = styled.article `
  ${ContainerStyles}
`;
const Inner = styled.div `
  height: 100%;
  display: flex;
  flex-direction: column;
`;
const MediaHolder = styled.div `
  ${imageWrapperPreserveRatio(556, 421, 556, 421)}
  overflow: hidden;
  background-color: ${brand.white};
`;
const ImageDesktop = styled.img `
  ${transition('transform')};
  ${imageCoverContainer()}

  @media ${until(Device.Tablet)} {
    display: none;
  }

  ${Container}:hover & {
    transform: scale(1.1);
  }
`;
const ImageMobile = styled.img `
  ${transition('transform')};
  ${imageCoverContainer()}
  border-radius: ${fluid(25, 50)} ${fluid(25, 50)} 0 0 ;

  @media ${from(Device.Tablet)} {
    display: none;
  }

  ${Container}:hover & {
    transform: scale(1.1);
  }

  @media (hover: none) { 
    ${Container}:hover & {
      transform: scale(1);
    }
  }
`;
const ContentArea = styled.div `
  background-color: ${brand.white};
  flex: 1;
  display: flex;
  flex-direction: column;

  [data-theme='dark'] & {
    background-color: ${brand.black};
  }
`;
const ContentInner = styled.div `
  padding: ${fluid(25, 48)} ${fluid(25, 80)};
  color: ${brand.black};
  height: 100%;
  display: flex;
  flex-direction: column;

  [data-theme='dark'] & {
    color: ${brand.white};
  }
`;
const Title = styled.h3 `
  ${fonts.montserrat.medium};
  font-size: ${fluid(18, 26)};
  line-height: ${fluid(24, 34)};
  margin-bottom: 16px;
`;
const Intro = styled.div `
  ${contentStyles};
  margin: 0 0 ${fluid(24, 42)};
`;
const FakeButton = styled.div `
  margin-top: auto;
  pointer-events: none;

  ${Container}:hover & {
    ${ButtonStyles.ButtonInner}::after {
      background-color: var(--hoverColour);
    }

    ${ButtonStyles.Text} {
      transform: translateY(-2px);
    }
  }
`;
const CategoryCardStyles = {
    ArticleContainer,
    Container,
    ContentArea,
    ContentInner,
    FakeButton,
    ImageDesktop,
    ImageMobile,
    Inner,
    Intro,
    MediaHolder,
    Title,
};
export default CategoryCardStyles;
